<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Profile</h1>
          <h2 class="subtitle">Here you can customize your profile</h2>
        </div>
      </div>
    </section>
    <div class="container" style="margin-top: 30px">
      <b-field label="Email">
        <b-input v-model="user.data.email" disabled></b-input>
      </b-field>

      <b-field label="WeChat">
        <b-input v-model="form.wechat"></b-input>
      </b-field>

      <b-field label="Telegram">
        <b-input v-model="form.telegram"></b-input>
      </b-field>

      <b-field label="Shop">
        <b-input v-model="form.shop"></b-input>
      </b-field>

      <div class="buttons is-pulled-right">
        <b-button type="is-primary" @click="submitForm">Save</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as firebase from "firebase";

export default {
  name: "Profile",
  data() {
    return {
      form: {
        wechat: "",
        telegram: "",
        shop: ""
      }
    };
  },
  created() {
    this.form.wechat = this.user.data.wechat;
    this.form.telegram = this.user.data.telegram;
    this.form.shop = this.user.data.shop;
  },
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: "user"
    })
  },
  methods: {
    submitForm() {
      const db = firebase.firestore();
      console.log(this.user)
      var userRef = db.collection("user").doc(this.user.data.id);

      return userRef
        .update({
          wechat: this.form.wechat,
          telegram: this.form.telegram,
          shop: this.form.shop
        })
        .then(() => {
          console.log(`User successfully updated!`);
          this.$buefy.notification.open({
            message: "Your profile has been updated",
            type: "is-success",
            hasIcon: true
          });
        })
        .catch(function(error) {
          console.error(`Error updating user: ${error}`);
          this.$buefy.notification.open({
            message: "Error sending data",
            type: "is-danger",
            hasIcon: true
          });
        });
    }
  }
};
</script>
